import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
  useInsertMyTaskSubmissionMutation,
  useUpdateMyTaskSubmissionMutation,
} from '@school_ify/schoolify-repository/src/student/types';

import Editor from 'components/TestEditor/Editor';
import { SERVICES_ENDPOINT } from 'utils/constants';
import Card from 'components/Card/Card';
import { studyDetailsState, updateSubject } from 'redux/study/studyDetails.slice';
import { useAppSelector } from 'redux/hooks';
import FileUploader from 'clean/components/common/FileUploader/FileUploader';

const SubmitAssignment = ({ model: assignmentData, callback }) => {
  const { t } = useTranslation();

  const [files, setFiles] = useState([]);

  const [insertMyTaskSubmissionMutation, insertData] = useInsertMyTaskSubmissionMutation();
  const [updateMyTaskSubmissionMutation, updateData] = useUpdateMyTaskSubmissionMutation();
  const { subjectIsUpdated } = useAppSelector(studyDetailsState);

  const dispatch = useDispatch();
  const [model, setModel] = useState<{
    id: string;
    assignment_id: string;
    text: string;
  }>();

  const saveFiles = async (assignmentSubmitId: string) => {
    const form = new FormData();
    form.append('foreign_id', assignmentSubmitId);
    form.append('table', 'AssignmentSubmits');
    files.forEach((file, index) => {
      if (file?.needsUpload) {
        form.append(`file${index}`, file);
      }
    });
    const options = {
      method: 'POST',
      body: form,
    };

    await fetch(`${SERVICES_ENDPOINT}/api/file/upload`, options);
  };

  async function save(submit = false) {
    let foreignId;
    if (!model.id) {
      const { data } = await insertMyTaskSubmissionMutation({
        variables: {
          assignment_id: model.assignment_id,
          content: model.text, // value for 'content'
          // @ts-ignore
          completed_at: submit ? new Date() : null, // value for 'completed_at'
          is_submited: submit, // value for 'is_submited'
        },
      });
      foreignId = data?.insert_assignment_submits_one?.id;
    }

    if (model.id) {
      await updateMyTaskSubmissionMutation({
        variables: {
          submission_id: model.id, // value for 'submission_id'
          is_submited: submit, // value for 'is_submited'
          content: model.text, // value for 'content'
          // @ts-ignore
          completed_at: submit ? new Date() : null, // value for 'completed_at'
        },
      });
      foreignId = model.id;
    }
    if (foreignId) await saveFiles(foreignId);
    dispatch(updateSubject(!subjectIsUpdated));
    callback();
  }

  useEffect(() => {
    setModel(assignmentData);
  }, [assignmentData]);

  return (
    <Card className="mt-1">
      {model && (
        <Card.Body>
          {/* @ts-ignore */}
          {insertData.errors && <div>{insertData.errors}</div>}
          {/* @ts-ignore */}
          {updateData.errors && <div>{updateData.errors}</div>}
          <div className="flex flex-col mb-1">
            <label htmlFor="content">{t('study:Assignment_submission')}</label>
            <FileUploader
              readOnly={assignmentData?.is_completed}
              files={files}
              setFiles={setFiles}
            />
          </div>
          <div className="flex flex-col">
            <label>Content</label>
            <Editor
              value={model.text}
              callback={val => {
                const obj = { ...model };
                obj.text = val;
                setModel(obj);
              }}
            />
          </div>
          <div className="flex gap-1 justify-center">
            <button
              onClick={() => save(true)}
              className="btn bg-secondary text-white border-none rounded-full mt-1"
            >
              Submit
            </button>
          </div>
        </Card.Body>
      )}
    </Card>
  );
};

export default SubmitAssignment;
